import React, {
  FC
} from 'react';
import clsx from 'clsx';

import {
  BurgerMenuIcon
} from 'src/shared/icons';

interface ToggleProps {
  toggled?: boolean;
  className?: string;
  onClick?: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

export const Toggle: FC<ToggleProps> = ({
  toggled = false,
  className,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={clsx(
        'rounded-full p-2 transition-colors',
        {
          'bg-white/20': !toggled,
        },
        {
          'bg-white/100': toggled,
        },
        className,
      )}
      onClick={onClick}
    >
      <div
        className="
          w-6 h-6
          flex items-center justify-center
        "
      >
        <BurgerMenuIcon
          className={clsx(
            'transition-colors',
            {
              'text-white': !toggled,
            },
            {
              'text-dark-blue': toggled,
            },
          )}
        />
      </div>
    </button>
  );
};
